export default "__VITE_ASSET__B8b6nRS5__"